import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandTimon(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path d="M12 21.6a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2Z" fill="#FF493C" />
      <path
        d="m14.999 15.21-1.812-3.585c-.195-.363-.72-.48-1.186-.48-.466 0-1.076.09-1.299.507l-1.667 3.506c-.057.105-.06.163-.044.203.09.216.758.33 1.47.39v.963a.1.1 0 0 0 .1.099h2.915a.1.1 0 0 0 .098-.1v-.935c.707-.049 1.382-.152 1.471-.366.016-.04.01-.087-.046-.203ZM12.017 10.82a1.27 1.27 0 1 0 0-2.54 1.27 1.27 0 0 0 0 2.54ZM16.12 9.72a1.267 1.267 0 1 0 0-2.534 1.267 1.267 0 0 0 0 2.534ZM18.268 11.25c-.105-.905-.359-1.181-1.318-1.181h-1.515c-.958 0-1.32.149-1.46 1.181l-.046.374 1.987 4.11h1.593a.1.1 0 0 0 .1-.099v-.896h.977a.1.1 0 0 0 .1-.099l-.418-3.39ZM7.88 9.72a1.267 1.267 0 1 0 0-2.534 1.267 1.267 0 0 0 0 2.534ZM5.733 11.25c.104-.905.358-1.181 1.317-1.181h1.518c.96 0 1.321.149 1.46 1.181l.045.36a.048.048 0 0 1-.004.027l-1.984 4.098H6.49a.1.1 0 0 1-.1-.1v-.896h-.977a.1.1 0 0 1-.099-.099l.418-3.39Z"
        fill="#fff"
      />
    </BaseIcon>
  );
}
